/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "http://h.cdn.pengpengla.com/up/openjs/1.3.3/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2);


/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function ($) {
	    window.UpLive = window.UpLive || {};
	    var invokeQueue = [];
	    var callbacks = [];
	    window.__domain = '*';
	
	    $(window).on('message', function (e) {
	        /**
	         *  e: {Object}
	         *  {
	         *      cbKey: 1, // 有cbKey，说明执行的是回调函数
	         *      result: '11'
	         *  }
	         */
	        var data = e.data;
	        try {
	            if (typeof data.cbKey == 'number') {
	                callbacks[data.cbKey](data.result);
	            } else if (typeof data == 'string' && data.indexOf('http://') > -1) {
	                window.__domain = data;
	            }
	            if (invokeQueue.length > 0) {
	                invokeQueue.forEach(function (item, index) {
	                    window.parent.postMessage(item, window.__domain);
	                });
	                invokeQueue = [];
	            }
	        } catch (e) {
	            console.log(e.message);
	        };
	    });
	    /**
	     * @param method {string} 触发操作方法 method
	     * @param param {Object} 配置数据
	     *          {
	     *              a: 1,
	     *              b: 2,
	     *              success: function(){}
	     *              failure: function(){}
	     *           }
	     */
	    function invoke(method, params) {
	        var ret = {},
	            callbackId,
	            p,
	            data = {};
	        try {
	            data = {
	                method: method
	            };
	            if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) == 'object') {
	                for (p in params) {
	                    if (params.hasOwnProperty(p) && params[p] !== null) {
	                        if (typeof params[p] == 'function') {
	                            callbackId = callbacks.push(params[p]) - 1;
	                            ret[p] = {
	                                cbKey: callbackId
	                            };
	                        } else {
	                            ret[p] = params[p];
	                        }
	                    }
	                }
	                data.params = ret;
	            } else {
	                data.params = params;
	            }
	            if (window.__domain) {
	                window.parent.postMessage(data, window.__domain);
	            } else {
	                invokeQueue.push(data);
	            }
	        } catch (e) {
	            alert(e.message);
	        }
	    }
	    $.extend(UpLive, {
	        invoke: invoke
	    });
	})(Zepto);

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// pcuplive.js